import { render, staticRenderFns } from "./customerAccepted.vue?vue&type=template&id=1a790a52&scoped=true&"
import script from "./customerAccepted.vue?vue&type=script&lang=js&"
export * from "./customerAccepted.vue?vue&type=script&lang=js&"
import style0 from "./customerAccepted.vue?vue&type=style&index=0&id=1a790a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a790a52",
  null
  
)

export default component.exports